import services from "../config/axios";
import base from "./base";

const skillManageAPI = {
    getSkillList(params: string) {
        return services.post(`${base.lk}/SkillManage/GetSkillList`, params);
    },
    getSkillApplicationDomainOptions(params = "") {
        return services.post(`${base.lk}/SkillManage/GetSkillApplicationDomainOptions`, params);
    },
    getSkillDetail(params: string) {
        return services.post(`${base.lk}/SkillManage/GetSkillDetail`, params);
    },
    getSkillInstallDetails(params: string) {
        return services.post(`${base.lk}/SkillManage/GetSkillInstallDetails`, params);
    },
    getSkillAuditLogs(params: string) {
        return services.post(`${base.lk}/SkillManage/GetSkillAuditLogs`, params);
    },
    getSkillManagePermissions(params = "") {
        return services.post(`${base.lk}/SkillManage/GetSkillManagePermissions`, params);
    },
    getSkillCreateOptions(params = "") {
        return services.post(`${base.lk}/SkillManage/GetSkillCreateOptions`, params);
    },
    createSkill(params: FormData) {
        return services.post(`${base.lk}/SkillManage/CreateSkill`, params);
    },
    getSkillVersions(params: string) {
        return services.post(`${base.lk}/SkillManage/GetSkillVersions`, params);
    },
    downloadSkillVersion(versionId: number) {
        return services.get(`${base.lk}/SkillManage/DownloadSkillVersion`, {
            params: { versionId },
            responseType: "blob",
        });
    },
    downloadSecurityAttachment(versionId: number) {
        return services.get(`${base.lk}/SkillManage/DownloadSecurityAttachment`, {
            params: { versionId },
            responseType: "blob",
        });
    },
    approveSkill(params: string) {
        return services.post(`${base.lk}/SkillManage/ApproveSkill`, params);
    },
    rejectSkill(params: string) {
        return services.post(`${base.lk}/SkillManage/RejectSkill`, params);
    },
    securityApproveSkill(params: FormData) {
        return services.post(`${base.lk}/SkillManage/SecurityApproveSkill`, params);
    },
    securityRejectSkill(params: FormData) {
        return services.post(`${base.lk}/SkillManage/SecurityRejectSkill`, params);
    },
    adminApproveSkill(params: string) {
        return services.post(`${base.lk}/SkillManage/AdminApproveSkill`, params);
    },
    adminRejectSkill(params: string) {
        return services.post(`${base.lk}/SkillManage/AdminRejectSkill`, params);
    },
    unpublishSkill(params: string) {
        return services.post(`${base.lk}/SkillManage/UnpublishSkill`, params);
    },
    setSkillFeatured(params: string) {
        return services.post(`${base.lk}/SkillManage/SetSkillFeatured`, params);
    },
};

export default skillManageAPI;
